// Stateless chunk transcription over ml-scribe. The endpoint returns the
// transcript as a bare string and persists nothing, which is what makes it the
// transport for builds with no streaming transcriber behind the dictation
// WebSocket.
import { getScribeHttpClients } from '@heidi/api/client';
import type { operations } from '@heidi/schema/ml-scribe';

// Read from the generated schema so a backend change to the response shape is
// a compile error here rather than empty transcripts at runtime.
type TranscribeContextResponse =
  operations['transcribe_context_api_v2_ml_scribe_sessions__session_id__restful_segment_transcription_transcribe_context_post']['responses'][200]['content']['application/json'];

interface ScribeHttp {
  post<T>(
    url: string,
    body?: unknown,
    config?: { signal?: AbortSignal; timeout?: number }
  ): Promise<{ data: T }>;
}

// `scribeHttpV2` base is /api/v2/ml-scribe/; scribe JWT injected by interceptor.
const http = (): ScribeHttp => getScribeHttpClients().scribeHttpV2;

// The route's backend latency tier is 45s; a chunk that has not answered by
// then is lost to the user anyway.
const TRANSCRIBE_CHUNK_TIMEOUT_MS = 45_000;

export interface TranscribeDictationChunkInput {
  sessionId: string;
  audio: Blob;
  signal?: AbortSignal;
}

export const transcribeDictationChunk = async ({
  sessionId,
  audio,
  signal,
}: TranscribeDictationChunkInput) => {
  const formData = new FormData();
  formData.append('file', audio, 'dictation-chunk.wav');

  const response = await http().post<TranscribeContextResponse>(
    `/sessions/${sessionId}/restful-segment-transcription/transcribe-context`,
    formData,
    { ...(signal ? { signal } : {}), timeout: TRANSCRIBE_CHUNK_TIMEOUT_MS }
  );
  return response.data;
};
